import BoxIcon from "@redotech/redo-icons/box-01.svg";
import { BooleanFilterOperator } from "@redotech/redo-model/views/advanced-filters/boolean-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const MissingBinsFilter: BooleanTableFilter = {
  type: AdvancedFilterType.BOOLEAN,
  data: {
    name: "missingBins",
    type: AdvancedFilterType.BOOLEAN,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: BoxIcon,
  displayName: "Missing bins",
  label: "Bin",
  boolDisplay: { falseDisplay: "not missing", trueDisplay: "missing" },
};
